"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var ShouldComponentUpdate_1 = require("../../../utils/ShouldComponentUpdate");
var ColorLookup_1 = __importDefault(require("../../../utils/ColorLookup"));
var Bar = /** @class */ (function (_super) {
    __extends(Bar, _super);
    function Bar() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.totalRadius = 114;
        _this.genRemainWidth = function () {
            var reservedCenter = 20;
            var chartOverview = _this.props.chartOverview;
            var chartData = chartOverview.filter(function (child) { return child.type === 'ProgressBar'; });
            var remain = _this.totalRadius;
            chartData.forEach(function (s) {
                if (s.props.width) {
                    remain -= s.props.width;
                }
            });
            var remainCount = chartData.filter(function (child) { return !child.props.width; }).length;
            var width = Math.round((remain - reservedCenter) / remainCount);
            return width;
        };
        _this.setRad = function () {
            var _a = _this.props, chartOverview = _a.chartOverview, index = _a.index;
            var chartData = chartOverview.filter(function (child) { return child.type === 'ProgressBar'; }).slice(0, index + 1);
            var sizes = [];
            var rad = _this.totalRadius;
            var autoWidth = _this.genRemainWidth();
            chartData.forEach(function (child) {
                var width = child.props.width ? child.props.width : autoWidth;
                var data = {
                    out: rad - 2,
                    in: rad - width,
                    index: child.index
                };
                sizes.push(data);
                rad = rad - width;
            });
            return sizes.find(function (size) { return size.index === index; });
        };
        return _this;
    }
    Bar.prototype.shouldComponentUpdate = function (nextProps) {
        return ShouldComponentUpdate_1.shouldComponentUpdate(this.props, nextProps);
    };
    Bar.prototype.componentDidUpdate = function () {
        this.props.onUpdate();
    };
    Bar.prototype.render = function () {
        return null;
    };
    Bar.prototype.getData = function (current) {
        if (current.series) {
            current.series.push(this.getOptions());
        }
        else {
            current.series = [this.getOptions()];
        }
        return current;
    };
    Bar.prototype.getOptions = function () {
        var _a = this.props, value = _a.value, name = _a.name, color = _a.color;
        var radData = this.setRad();
        var setColor = color ? ColorLookup_1.default(color) : undefined;
        var series = {
            type: 'solidgauge',
            name: name,
            events: {},
            data: [{
                    radius: radData.out,
                    color: setColor,
                    innerRadius: radData.in,
                    y: value
                }]
        };
        series = this.bindEvents(series);
        return series;
    };
    Bar.prototype.bindEvents = function (options) {
        var _a = this.props, mouseOut = _a.mouseOut, mouseOver = _a.mouseOver, onClick = _a.onClick;
        if (onClick) {
            options.events.click = function (e) { return onClick(e.point); };
        }
        if (mouseOver) {
            options.events.mouseOver = function (e) { return mouseOver(e.target.name); };
        }
        if (mouseOut) {
            options.events.mouseOut = function (e) { return mouseOut(e.target.name); };
        }
        return options;
    };
    return Bar;
}(react_1.Component));
exports.default = Bar;
//# sourceMappingURL=Bar.js.map